import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Paper, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Offer } from '../../interfaces/Offer/Offer';
import { getOffers } from '../../api/Offer';
import { sharedColors, sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { OffersTable } from './OffersTable';

const LegendItem = ({ label, color }: { label: string; color: string }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      gap: 0.5,
      alignItems: 'center',
    }}
  >
    <Box
      sx={{
        width: 12,
        height: 12,
        borderRadius: '50%',
        backgroundColor: color,
      }}
    />
    <Typography sx={{ fontWeight: 400, fontSize: '12px' }}>{label}</Typography>
  </Box>
);

export const OffersPage = () => {
  const navigate = useNavigate();

  const [offers, setOffers] = useState<Offer[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshOffers = () => {
    setLoading(true);
    getOffers()
      .then(setOffers)
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshOffers();
  }, []);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Kampanyalar
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/sales/offers/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Kampanya
      </Button>
      <OffersTable offers={offers} />

      <Paper
        sx={{ display: 'flex', flexDirection: 'row', gap: 1.5, mt: 1, p: 1 }}
      >
        <LegendItem label='Gelecek Kampanya' color={sharedColors.blue2} />
        <LegendItem
          label='Aktif Kampanya'
          color={sharedColors.statusGreenLightest}
        />
        <LegendItem
          label='İnaktif Kampanya'
          color={sharedColors.statusRedLightest}
        />
      </Paper>
    </Box>
  );
};
